import { jsx as _jsx } from "preact/jsx-runtime";
import IconHeartSmall from '@wikia/react-common/icons/IconHeartSmall';
import IconHeartFilledSmall from '@wikia/react-common/icons/IconHeartFilledSmall';
import IconHeart from '@wikia/react-common/icons/IconHeart';
import IconHeartFilled from '@wikia/react-common/icons/IconHeartFilled';
export function SmallHeartIcon({ isFilled, className }) {
    return isFilled ? (_jsx(IconHeartFilledSmall, { className: `wds-icon wds-icon-small ${className}` }, void 0)) : (_jsx(IconHeartSmall, { className: `wds-icon wds-icon-small ${className}` }, void 0));
}
export function HeartIcon({ isFilled, className }) {
    return isFilled ? (_jsx(IconHeartFilled, { className: `wds-icon ${className}` }, void 0)) : (_jsx(IconHeart, { className: `wds-icon ${className}` }, void 0));
}
